module.exports = __webpack_public_path__ + "static/img/larval-identification.32ff0ab.svg";